import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-centered" }
const _hoisted_2 = { class: "setup-card casino-card-glow" }
const _hoisted_3 = {
  key: 0,
  class: "setup-options"
}
const _hoisted_4 = {
  key: 1,
  class: "setup-form"
}
const _hoisted_5 = {
  key: 2,
  class: "setup-form"
}
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "overlay"
}
const _hoisted_9 = { class: "setup-card casino-card-glow modal-card" }
const _hoisted_10 = { class: "mono" }
const _hoisted_11 = { class: "checkbox-label" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "setup-brand" }, [
        _createElementVNode("span", { class: "brand-icon" }, "₿")
      ], -1)),
      _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "setup-title" }, "Arkade Coinflip", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("p", { class: "setup-subtitle text-muted" }, "Trustless Bitcoin coin flips on Ark", -1)),
      (!_ctx.mode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "option-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mode = 'create'))
            }, [...(_cache[10] || (_cache[10] = [
              _createStaticVNode("<div class=\"option-icon-wrap\" data-v-647d9c28><span class=\"option-icon\" data-v-647d9c28>+</span></div><div class=\"option-text\" data-v-647d9c28><span class=\"option-label\" data-v-647d9c28>Create New Wallet</span><span class=\"option-desc\" data-v-647d9c28>Generate a fresh keypair</span></div>", 2)
            ]))]),
            _createElementVNode("button", {
              class: "option-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'restore'))
            }, [...(_cache[11] || (_cache[11] = [
              _createStaticVNode("<div class=\"option-icon-wrap\" data-v-647d9c28><span class=\"option-icon\" data-v-647d9c28>↺</span></div><div class=\"option-text\" data-v-647d9c28><span class=\"option-label\" data-v-647d9c28>Restore Wallet</span><span class=\"option-desc\" data-v-647d9c28>Import from nsec key</span></div>", 2)
            ]))])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'create')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "warning-box" }, " Your private key will be shown once. Save it securely! ", -1)),
            _createElementVNode("button", {
              class: "btn-gold btn-lg",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createWallet && _ctx.createWallet(...args))),
              style: {"width":"100%"}
            }, " Generate Wallet "),
            _createElementVNode("button", {
              class: "btn-outline",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = '')),
              style: {"width":"100%"}
            }, "Back")
          ]))
        : _createCommentVNode("", true),
      (_ctx.mode === 'restore')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.privateKey) = $event)),
              placeholder: "nsec1..."
            }, null, 512), [
              [_vModelText, _ctx.privateKey]
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-primary btn-lg",
              disabled: !_ctx.privateKey,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.restoreWallet && _ctx.restoreWallet(...args))),
              style: {"width":"100%"}
            }, " Restore ", 8, _hoisted_7),
            _createElementVNode("button", {
              class: "btn-outline",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mode = '')),
              style: {"width":"100%"}
            }, "Back")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showPrivateKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "modal-title text-gold" }, "Your Private Key", -1)),
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "modal-desc text-muted" }, "Save this key securely. It cannot be recovered!", -1)),
                _createElementVNode("div", {
                  class: "key-box",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.copyKey && _ctx.copyKey(...args)))
                }, [
                  _createElementVNode("code", _hoisted_10, _toDisplayString(_ctx.newPrivateKey), 1),
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "key-hint" }, "Click to copy", -1))
                ]),
                _createElementVNode("label", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.hasBackedUp) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.hasBackedUp]
                  ]),
                  _cache[17] || (_cache[17] = _createTextVNode(" I have safely stored my private key ", -1))
                ]),
                _createElementVNode("button", {
                  class: "btn-gold btn-lg",
                  disabled: !_ctx.hasBackedUp,
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args))),
                  style: {"width":"100%"}
                }, " Continue ", 8, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}